import Vue from "vue";
import store from "@/store";

function hexToRgb(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
}


export function setThemeStyle() {
  Vue.prototype.$api.system.getThemeSkin().then(res => {
    console.log(res,17)
    if(res){
      store.commit('SETTHEMEITEM', res)
      let styles = res.styles;
      let themeColor = res.themeColor;
      let iconColor = res.iconColor;
      //图片更改
      // console.log(document.getElementById('loginLogo'))
      // document.getElementById('loginLogo').src(styles.find(item=>item.styleType==1).styleUrl);
      let hexArr = hexToRgb(res.themeColor);
      let hexIconArr = hexToRgb(res.iconColor);
  
      let style = document.createElement('style');
      let cssRules = '';
      if (styles.find(item => item.styleType == 2).styleUrl) {
        cssRules += `
        .login-page {
          background-image: url(${styles.find(item => item.styleType == 2).styleUrl}) !important;
          background-position: center center;
          background-size: cover;
        }`;
      }
// 设置要生成的CSS规则
      cssRules += `
    .login-page .login-container .login-tab span.active,
    .login-page .login-container .login-form .input-wrap .code-text.unsent,
    .container .reset-password-form .verification-code,
    .login-page .login-container .organization-wrap .scroll-box .content-box .content-item__active,
    .schedule-date-back,
    .schedule-lis .scroll-container .empty-box p span,
    .schedule-lis .scroll-container .lis .right-icon > .el-icon-circle-check,
    .message-dialog .msg-fd .el-button--text,
    .login-page .login-container .local-qr-code-box .box-title p:nth-child(1){
      color:${themeColor} !important;
    }
    .login-page .login-container .common-handle .login-btn.el-button--primary.is-disabled,
 
    .container .login-btn.el-button--primary.is-disabled,
    .container .login-btn.el-button--primary.is-disabled:hover,
    .login-page .login-container .organization-wrap .wrap-bottom .confirm-btn.el-button--primary.is-disabled,
    .el-dialog .el-dialog__footer .dialog-footer .el-button.btn-save__schedule.is-disabled,
    .el-dialog .el-dialog__footer .dialog-footer .el-button.btn-save__schedule.is-disabled:hover{
      background-color:rgba(${hexArr[0]},${hexArr[1]},${hexArr[2]},0.2) !important;
    }
    .login-box .corner-mark{
      background: linear-gradient(45deg, transparent, transparent 47%, ${themeColor} 49%, ${themeColor} 100%) !important;
    }
    .el-dialog .el-dialog__footer .dialog-footer .el-button.btn-save__schedule.is-disabled{
       border:unset;
    }
    .el-button--primary:hover,.el-button--primary:focus,
    .login-page .login-container .login-form .box-input:focus,
    .login-page .login-container .organization-wrap .scroll-box .content-box .content-item__active,
    .el-dialog .el-dialog__footer .dialog-footer .el-button.btn-save__schedule,
    .message-dialog .msg-fd .el-button--primary{
      border-color:${themeColor} !important;
    }
    .el-button--primary:hover,.el-button--primary:focus,
    .login-page .login-container .common-handle .login-btn,
    .container .login-btn,
    .container .login-btn.el-button--primary:hover,
    .container .login-btn.el-button--primary:focus,
    .login-page .login-container .organization-wrap .wrap-bottom .confirm-btn,
    .el-calendar .el-calendar__body .el-calendar-table td.is-selected p,
    .el-calendar .el-calendar__body .el-calendar-table td:hover p,
    .el-calendar .el-calendar__body .el-calendar-table td .el-calendar-day p .is-schedule:after,
    .schedule-lis .scroll-container .lis:after,
    .schedule-lis .schedule-header .add-icon,
    .msg-float-border,
    .schedule-lis .schedule-header .badge,
    .badge,
    .el-dialog .el-dialog__footer .dialog-footer .el-button.btn-save__schedule,
    .message-dialog .msg-fd .el-button--primary,
    .login-type-popper{
      background-color:${themeColor} !important;
    }
    .el-popper.login-type-popper .popper__arrow,.el-popper.login-type-popper .popper__arrow::after{
      border-left-color:${themeColor} !important;
    }
`;
      if (styles.find(item => item.styleType == 5).styleUrl) {
        cssRules += `
         .home-page{
            background: url(${styles.find(item => item.styleType == 5).styleUrl}) no-repeat center center !important;
            background-size: cover !important;
          }`;
      }
      if (styles.find(item => item.styleType == 6).styleUrl) {
        cssRules += `
          .user-info{
            background: url(${styles.find(item => item.styleType == 6).styleUrl}) no-repeat center top !important;
            background-size: 100% auto !important;
          }`;
      }
      if (styles.find(item => item.styleType == 7).styleUrl) {
        cssRules += `
          .index-container .develop-block-wrap .develop-block,.index-container .develop-block-wrap .develop-block.empty{
            background: url(${styles.find(item => item.styleType == 7).styleUrl}) no-repeat center top !important;
            background-size: 100% auto !important;
          }`;
      }
      if (styles.find(item => item.styleType == 8).styleUrl) {
        cssRules += `
         .process-center{
            background: url(${styles.find(item => item.styleType == 8).styleUrl}) no-repeat center top !important;
            background-size:100% auto !important;
            background-color:#fff !important;
          }`;
      }
  
      if (styles.find(item => item.styleType == 9).styleUrl) {
        cssRules += `
         .board-wrap .board{
            background: url(${styles.find(item => item.styleType == 9).styleUrl}) no-repeat center top !important;
            background-size:100% auto !important;
            background-color:#fff !important;
          }`;
      }
      if (styles.find(item => item.styleType == 10).styleUrl) {
        cssRules += `
          .schedule-manage{
            background: url(${styles.find(item => item.styleType == 10).styleUrl}) no-repeat center top !important;
            background-size:100% auto !important;
            background-color:#fff !important;
          }`;
      }
      if (styles.find(item => item.styleType == 11).styleUrl) {
        cssRules += `
          .meeting{
            background: url(${styles.find(item => item.styleType == 11).styleUrl}) no-repeat center top !important;
            background-size:100% auto !important;
            background-color:#fff !important;
          }`;
      }
      if (styles.find(item => item.styleType == 12).styleUrl) {
        cssRules += `
         .message-center{
            background: url(${styles.find(item => item.styleType == 12).styleUrl}) no-repeat center top !important;
            background-size:100% auto !important;
            background-color:#fff !important;
         }`;
      }
      if(iconColor){
        cssRules+=`
      .enterprise-popover-trigger .enterprise-popover-arrow,.app-content-btn.on{
          color:${iconColor} !important;
       }
       .fast-bottom .dot.active{
          background-color:${iconColor} !important;
       }
       .app-content-btn.off{
          color:rgba(${hexIconArr[0]},${hexIconArr[1]},${hexIconArr[2]},0.6) !important;
       }
       .fast-bottom .dot{
           background-color:rgba(${hexIconArr[0]},${hexIconArr[1]},${hexIconArr[2]},0.6) !important;
       }
       .msg-icon .badge{
           background-color:${iconColor} !important;
           color:${themeColor} !important;
       }`
      }
      // 将CSS规则写入style元素内部
      style.innerHTML = cssRules;
      // 将style元素添加到HTML文档头部或者body尾部（取决于需求）
      document.head.appendChild(style); // 在<head>标签中添加
    }else{
      store.commit('SETTHEMEITEM', null)
    }
    
  })
}


